export default __webpack_public_path__ + "static/media/devices.ac7e91e6.png";